export default __webpack_public_path__ + "4647d4099924741eb8fb4e915990853e.png";